import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_103: FaireProductEntity = {
  token: "legacy_prod_abbott-103",
  type: "product",
  name: 'Large Sheep on Legs Planter 3" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/137e3e56d9470a40264b40e3771b016096f4948d2b87721677a59f1d65970944.jpeg",
  priceDollars: 22,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
